<div class="row">
    <div class="col-xl-4 col-lg-6">
        <a class="card card-box-hover-rise mb-5" [routerLink]="">
            <div class="card-badges">
                <span class="badge badge-pill badge-warning">Warning</span>
            </div>
            <img alt="..." class="card-img-top" src="assets/images/stock-photos/stock-1.jpg"/>
            <div class="card-body card-body-avatar">
                <div class="avatar-icon-wrapper avatar-icon-wrapper--sm">
                    <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar2.jpg"/></div>
                </div>
                <h5 class="card-title font-weight-bold font-size-lg">Card title</h5>
                <p class="card-text">Some quick example text to build on the card title and make up the bulk of the
                    card's content.</p>
                <div class="card-date mt-2">
                    <fa-icon [icon]="['far', 'clock']" class="text-muted mr-1"></fa-icon>
                    <small class="text-muted">
                        added moments ago
                    </small>
                </div>
            </div>
        </a>
    </div>
    <div class="col-xl-4 col-lg-6">
        <a class="card card-box-hover-rise mb-5" [routerLink]="">
            <div class="card-badges">
                <span class="badge badge-pill badge-success">Success</span>
                <span class="badge badge-pill badge-neutral-info text-info">Info</span>
            </div>
            <img alt="..." class="card-img-top" src="assets/images/stock-photos/stock-2.jpg"/>
            <div class="card-body card-body-avatar">
                <div class="avatar-icon-wrapper avatar-icon-wrapper--sm">
                    <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar2.jpg"/></div>
                </div>
                <h5 class="card-title font-weight-bold font-size-lg">Card title</h5>
                <p class="card-text">Some quick example text to build on the card title and make up the bulk of the
                    card's content.</p>
                <div class="card-date mt-2">
                    <fa-icon [icon]="['far', 'clock']" class="text-muted mr-1"></fa-icon>
                    <small class="text-muted">
                        added moments ago
                    </small>
                </div>
            </div>
        </a>
    </div>
    <div class="col-xl-4 col-lg-12">
        <a class="card card-box-hover-rise mb-5" [routerLink]="">
            <div class="card-badges">
                <span class="badge badge-danger">Danger</span>
            </div>
            <img alt="..." class="card-img-top" src="assets/images/stock-photos/stock-3.jpg"/>
            <div class="card-body card-body-avatar">
                <div class="avatar-icon-wrapper avatar-icon-wrapper--sm">
                    <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar2.jpg"/></div>
                </div>
                <h5 class="card-title font-weight-bold font-size-lg">Card title</h5>
                <p class="card-text">Some quick example text to build on the card title and make up the bulk of the
                    card's content.</p>
                <div class="card-date mt-2">
                    <fa-icon [icon]="['far', 'clock']" class="text-muted mr-1"></fa-icon>
                    <small class="text-muted">
                        added moments ago
                    </small>
                </div>
            </div>
        </a>
    </div>
</div>
